import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup} from 'reactstrap';
import { ajaxWrapperPost, ajaxWrapperGet, ajaxWrapperDelete } from '../../../utils/deviceAPI';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import LoadingIndicator from '../../../utils/LoadingIndicator';
import { AppSwitch } from '@coreui/react'
import UsersNotificationSystem from '../../Admin/Users/UsersNotificationSystem';

import Widget02 from '../../Widgets/Widget02';
const duration = 300;



class Configuration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUserBeingEdited: 0,
            currentUserBeingEditedFirstName: "",
            currentUserBeingEditedLastName: "",
            currentUserBeingEditedEmail: "",
            currentUserBeingEditedControl: 0,
            currentUserBeingEditedControlUpdated: false,
            modalEditUser: false,
            loading: true,
            comfirmUserIdDelete: "",
            confirmUserIdDeleteValid: false,
            comfirmUserIdDeleteMessage: "",
            doesSiteHaveControl: false
        };
        this.toggleEdit = this.toggleEdit.bind(this);
        this.toggleControl = this.toggleControl.bind(this);
        this.updateSiteUser = this.updateSiteUser.bind(this);
        this.deleteSiteUser = this.deleteSiteUser.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.setData();
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.setData(newDev);
        }
    }
    componentWillUnmount(){

    }

    setData(device = this.props.match.params.dev.replace('device_','')) {
        ajaxWrapperGet('/api/siteUserControlData',device).then((data) => {
            this.setState({
                data,
                loading: false,
                currentUserBeingEdited: 0,
                currentUserBeingEditedFirstName: "",
                currentUserBeingEditedLastName: "",
                currentUserBeingEditedEmail: "",
                currentUserBeingEditedControl: 0,
                currentUserBeingEditedControlUpdated: false,
                doesSiteHaveControl: (data[0].deviceControl === 1)
            });

        });
    }


    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
                [name]: value
            },
            () => { this.validateField(name, value) }

        );
    }
    validateField(fieldName, value) {
        let _confirmUserIdDeleteValid = this.state.confirmUserIdDeleteValid;
        let _comfirmUserIdDeleteMessage = this.state.comfirmUserIdDeleteMessage;
        switch(fieldName) {
            case 'comfirmUserIdDelete':
                _confirmUserIdDeleteValid = this.state.currentUserBeingEditedEmail === value;
                _comfirmUserIdDeleteMessage = this.state.currentUserBeingEditedEmail === value ? "" : "Email address does not match.";
                break;
        }
        this.setState({
            confirmUserIdDeleteValid: _confirmUserIdDeleteValid,
            comfirmUserIdDeleteMessage: _comfirmUserIdDeleteMessage
        });
    }

    userBeingEdited(id = 0, firstName = "", lastName = "", email = "", control = false) {
        this.setState({
            currentUserBeingEdited: id,
            currentUserBeingEditedFirstName: firstName,
            currentUserBeingEditedLastName: lastName,
            currentUserBeingEditedEmail: email,
            currentUserBeingEditedControl: control,
            currentUserBeingEditedControlUpdated: control
        });
    }

    toggleEdit() {
        this.setState({
            modalEditUser: !this.state.modalEditUser
        });
    }
    toggleControl(e) {
        this.setState({
            currentUserBeingEditedControlUpdated: !this.state.currentUserBeingEditedControlUpdated
        });
    }
    updateSiteUser() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            userToModify: this.state.currentUserBeingEdited,
            userToModifyControl: this.state.currentUserBeingEditedControlUpdated
        };
        ajaxWrapperPost('/api/siteUserControlDataUpdateUser',postData).then((data) => {
            this.toggleEdit();
            this.setData();
        });
    }
    deleteSiteUser() {
        let postData = {
            dev: this.props.match.params.dev.replace('device_',''),
            userToModify: this.state.currentUserBeingEdited,
            userToModifyControl: this.state.currentUserBeingEditedControlUpdated
        };
        ajaxWrapperPost('/api/siteUserRemoveUser',postData).then((data) => {
            this.toggleEdit();
            this.setData();
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        const { data } = this.state;
        return (
            <div className="containerAnimation">
                <div className="fadeInUp">
                <Row>
                    <Col xs="12" md="12" lg="12" xl="12">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-2">
                                    <Col sm="12">
                                        <CardTitle className="mb-0">Users and Access Levels</CardTitle>
                                        <div className="small text-muted">user permissions for this site.</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <hr className="mb-4"/>
                                    </Col>
                                </Row>
                                <Row className="pb-2">
                                    <Col sm="12">
                                        <ul className="icons-list mb-5 list-inline">
                                        {data.map((user,index) => {
                                            return (
                                                <li key={index} className="mb-3 mt-4 listSiteItems">
                                                    <i className={"fa fa-user" + (user.deviceAdmin ? "-circle-o text-success" : " text-muted")}></i>
                                                    <div className="desc-n">
                                                        <div className="title">{user.firstname} {user.lastname} {user.deviceAdmin ? "*" : ""}</div>
                                                        <div className="small text-uppercase pb-3 text-muted">{user.company} <span className="text-secondary">|</span> <span className="text-lowercase">{user.email}</span> </div>
                                                    </div>
                                                    {user.deviceControl === 1 && (
                                                        <div className="value mr-4">
                                                            <div className="small text-muted">Control</div>
                                                            <div className={"small text-" + (user.control ? "danger" : "muted")}>{user.control ? "Yes" : "No" }</div>
                                                        </div>
                                                    )}
                                                    <div className="actions">
                                                        <Button color="link" className="text-muted" onClick={() => {this.toggleEdit(); this.userBeingEdited(user.id, user.firstname, user.lastname, user.email, user.control === 1)}}><i className="fa fa-pencil-square"></i></Button>
                                                    </div>
                                                </li>
                                            )
                                        })
                                        }
                                        </ul>
                                        <Modal isOpen={this.state.modalEditUser} toggle={this.toggleEdit} >

                                            <ModalBody>
                                                <Row>
                                                    <Col sm="10">
                                                        <CardTitle className="mb-1">Edit User</CardTitle>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12">
                                                        <hr className="mb-4"/>
                                                    </Col>
                                                </Row>
                                                <Row className="pb-2">
                                                    <Col sm="12">
                                                        <div className="text-justify">{this.state.currentUserBeingEditedFirstName} {this.state.currentUserBeingEditedLastName}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="pb-2">
                                                    <Col sm="12">
                                                        <div className="small text-muted">{this.state.currentUserBeingEditedEmail}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="pt-5">
                                                    <Col sm="12">
                                                        <div className="text-uppercase">Remove User</div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="12">
                                                        <hr className="mb-4"/>
                                                    </Col>
                                                </Row>
                                                <Row className="pb-4">
                                                    <Col sm="12">
                                                        <Row className="pb-3">
                                                            <Col sm="12">
                                                                <div className="small text-muted">Please type the user's email address and click Remove to remove user from the site.</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="8">
                                                                <Input type="text" placeholder="Confirm User's Email" id="comfirmUserIdDelete" name="comfirmUserIdDelete" className={this.state.confirmUserIdDeleteValid ? "is-valid" : "is-invalid"} value={ this.state.comfirmUserIdDelete } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                                {this.state.comfirmUserIdDeleteMessage.length <= 0 ? "" :
                                                                    <div className="invalid-feedback" id="passwordError" >{this.state.comfirmUserIdDeleteMessage}</div>
                                                                }
                                                            </Col>
                                                            <Col sm="4">
                                                                <Button color="danger" className="btn btn-block" onClick={this.deleteSiteUser} disabled={!this.state.confirmUserIdDeleteValid}>Remove</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                {this.state.doesSiteHaveControl && (
                                                    <div>
                                                        <Row className="pt-5">
                                                            <Col sm="12">
                                                                <div className="text-uppercase">Site Access</div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col sm="12">
                                                                <hr className="mb-4"/>
                                                            </Col>
                                                        </Row>
                                                        <Row className="pb-2">
                                                            <Col sm="9">
                                                                <div className="small text-muted">Control</div>
                                                            </Col>
                                                            <Col sm="3">
                                                                <FormGroup>
                                                                    <Label className="switch switch-icon switch-pill switch-primary-outline">
                                                                        <AppSwitch className={'mx-1'} color={'primary'} label id="currentUserBeingEditedControl" checked={this.state.currentUserBeingEditedControlUpdated} onChange={ this.toggleControl } />
                                                                    </Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    )}
                                                <Row>
                                                    <Col sm="12">
                                                        <hr className="mb-4"/>
                                                    </Col>
                                                </Row>
                                                <Row className="pb-4">
                                                    <Col sm="6" className="small text-muted">
                                                        <Button color="link" className="btn btn-block" onClick={this.toggleEdit}>Cancel</Button>
                                                    </Col>
                                                    <Col sm="6" className="small text-muted">
                                                        <Button color="success" className="btn btn-block" onClick={this.updateSiteUser} disabled={this.state.currentUserBeingEditedControl == this.state.currentUserBeingEditedControlUpdated}>Update</Button>
                                                    </Col>
                                                </Row>
                                            </ModalBody>
                                        </Modal>
                                    </Col>
                                </Row>

                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            </div>
        )
    }
}


export default Configuration;



// WEBPACK FOOTER //
// ./src/views/site/Users/Users.js